<app-dc-header class="header">
  <ng-container class="heading">{{ issuerName ? issuerName : 'Issuer Contacts' }}</ng-container>
  <ng-container class="actions">
    <button type="button" class="btn btn-link downloadText d-flex align-item-center" (click)="refreshPage()">
      Refresh &nbsp;<i class="fas fa-refresh fs-4"></i>
    </button>
    <app-dc-download-csv
      [disabled]="disableCsvBtn"
      [fileTitle]="'Issuers Contacts'"
      (click)="downloadCsvRequest(true)"
      [title]="disableCsvBtn ? 'CSV Downloading...' : 'CSV Download'"
      #csvDownloadComponent
    ></app-dc-download-csv>
    <button type="button" class="btn btn-sm btn-primary" (click)="openAddContactModal(createContactModal)">
      Add Issuer Contact
    </button>
  </ng-container>
</app-dc-header>
<div class="nav">
  <a href="" [routerLink]="['/issuers']" class="btn btn-sm btn-tab">Issuers</a
  ><a href="" [routerLink]="['/issuers/contacts']" class="btn btn-sm btn-tab active">Contacts</a>
</div>
<app-dc-pane [noPadding]="false" [headerSearch]="true" [tableContainer]="true" [loading]="loading" class="d-block main">
  <ng-container class="heading">List of Issuer Contacts</ng-container>
  <ng-container class="headingAction">
    <app-dc-table-search (searchValue)="updateFilter($event)"></app-dc-table-search>
  </ng-container>

  <app-dc-table
    *ngIf="rows?.length > 0"
    #table
    [rows]="rows"
    [columns]="columns"
    [messages]="messages"
    [sort]="sortOrder"
    [showFooter]="false"
    [scrollV]="true"
    (action)="tableAction($event)"
    (activate)="tableActivate($event)"
    [filterValue]="searchTextValue"
  ></app-dc-table>
  <div *ngIf="!loading && rows?.length < 1">
    <p class="lead text-center">No Issuer Contacts</p>
    <p class="text-muted text-center">Use the 'Add' button to create issuer contacts</p>
  </div>
  <!-- <div *ngIf="loading">
      <app-dc-loading class="contactsPadding"></app-dc-loading>
    </div> -->
</app-dc-pane>

<ng-template #createContactModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">New Issuer Contact</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">Close</span>
    </button>
  </div>
  <div class="modal-body">
    <deltacapita-create-issuer-contact [modal]="modal"></deltacapita-create-issuer-contact>
  </div>
</ng-template>

<ng-template #actionButtonTemplate ngx-datatable-cell-template let-row="row" let-value="value">
  <div ngbDropdown class="d-inline-block" container="body" placement="left" display="dynamic">
    <fa-icon [icon]="faEllipsisV" class="mr-2 icon-color fa-lg" id="dropdownMenu1" ngbDropdownToggle></fa-icon>
    <div class="dropdown-menu" aria-labelledby="dropdownMenu1" ngbDropdownMenu>
      <button
        class="dropdown-item"
        (click)="openInviteModal(row)"
        [ngClass]="isIssuerAlreadyInvited(row) ? 'dropdown-item-disabled' : ''"
        [ngbPopover]="disabledAsAlreadyInvited"
        triggers="{{ isIssuerAlreadyInvited(row) ? 'mouseenter:mouseleave' : null }}"
      >
        <img class="mr-2" src="assets/publish_to_distributor.svg" /> Invite User to Platform
      </button>
      <button
        class="dropdown-item"
        [ngClass]="isIssuerAlreadyInvited(row) ? '' : 'dropdown-item-disabled'"
        (click)="openReinviteModal(row)"
        [ngbPopover]="disabledAsNotInvited"
        triggers="{{ isIssuerAlreadyInvited(row) ? null : 'mouseenter:mouseleave' }}"
      >
        <img class="mr-2" src="assets/mail.svg" /> Re-send Invitation
      </button>
      <button class="dropdown-item" (click)="editContactModal(editSalesContactDataModal, row)">
        <img class="mr-2" src="assets/view_ddq.svg" /> Edit Issuer Sales Contact
      </button>
      <button class="dropdown-item" (click)="openDeleteModal(row)">
        <img class="mr-2" src="assets/bin.svg" /> Delete Contact
      </button>
    </div>
  </div>
</ng-template>

<ng-template #disabledAsAlreadyInvited>
  <div [innerHtml]="'This issuer contact has already been invited to the platform.'"></div>
</ng-template>

<ng-template #disabledAsNotInvited>
  <div [innerHtml]="'This issuer contact has not been invited to the platform yet.'"></div>
</ng-template>

<ng-template #editSalesContactDataModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Issuer Sales Contact</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">Close</span>
    </button>
  </div>
  <div class="modal-body">
    <deltacapita-edit-issuer-contact [modal]="modal"></deltacapita-edit-issuer-contact>
  </div>
</ng-template>

<ng-template #issuerNameLinkTemplate ngx-datatable-cell-template let-value="value" let-row="row">
  <span
    ><a class="name-link" [routerLink]="['/issuers', row.issuerid]" [title]="value">
      {{ value }}
    </a></span
  >
</ng-template>

<ng-template #issuerContactLinkTemplate ngx-datatable-cell-template let-value="value" let-row="row">
  <span
    ><a class="name-link" [routerLink]="['/admin/user/list', row.email]" [title]="value">
      {{ value }}
    </a></span
  >
</ng-template>
